import Emitter from './services/emitter';
import mElectronApi from './util/electron';
import { isWeb } from './util/env';
import env from './reducers/env';
import user from './reducers/user';
import store from './reducers';
import config from './config';
import { setTitle, checkUpdate, onbeforeunload } from './reducers/listeners/common';

const isSDK = config.showCopyrightLogo;

const doWebOnly = () => {
    // 设置当前的环境状态
    store.dispatch(env.setEnv('web'));
    // 增加离开页面检测
    onbeforeunload();
};

const doPcOnly = () => {
    checkUpdate(store, true);
};

const doAfterUserStateCheck = (isLogin) => {
    if (!isLogin) return;
    setTimeout(() => {
        // TODO: for pc, 500ms 的 setTimeout 待优化
        Emitter.emit('SyncList', () => { }, () => { });
    }, 500);
};

const addEvents = () => {
    Emitter.on('Login', () => {
        doAfterUserStateCheck(true);
    });

    Emitter.on('SwitchLanguage', () => {
        setTimeout(() => {
            setTitle(store);
        }, 0);
    });
};

(() => {
    require('./reducers/listeners/connect').default(store);
    require('./reducers/listeners/mscratch').default(store);
    if (!isSDK) {
        require('./reducers/listeners/user').default(store);
        require('./reducers/listeners/menu').default(store);
        require('./reducers/listeners/project').default(store);
    }
    if (isWeb()) {
        doWebOnly();
    } else {
        doPcOnly();
    }

    // 定制版本sdk无需以下逻辑
    if (!isSDK) {
        addEvents();
        if (mElectronApi.has('electron')) {
            require('./reducers/listeners/electron').default(store);
        }
        setTitle(store);
        // 检查用户登录状态
        if (!user.checkUserTokenExist()) {
            doAfterUserStateCheck(false);
        }
        store.dispatch(user.getUserState());
    }
})();